export default {
    "score": 0,
    "party": {
        "units": {
            "donna": {
                "key": "donna",
                "points": 1,
                "isUnlocked": true,
                "class": "donna",
                "affiliation": "good"
            },
            "blitz": {
                "key": "blitz",
                "points": 1,
                "isUnlocked": true,
                "class": "blitz",
                "affiliation": "good",
            },
            "apple": {
                "key": "apple",
                "points": 2,
                "isUnlocked": false,
                "class": "z",
                "affiliation": "good",
            },
            "jasmine": {
                "key": "jasmine",
                "points": 3,
                "isUnlocked": false,
                "class": "jasmine",
                "affiliation": "good"
            },

            "plant1": {
                "points": 1,
                "isUnlocked": true,
                "key": "plant1",
                "class": "bunnion",
            },
            "plant2": {
                "points": 1,
                "isUnlocked": true,
                "key": "plant2",
                "class": "bunnion",
            },
            "plant3": {
                "points": 1,
                "isUnlocked": true,
                "key": "plant3",
                "class": "bunnion",
            },
            "plant4": {
                "points": 2,
                "isUnlocked": false,
                "key": "plant4",
                "class": "corndog",
            },
            "plant4b": {
                "points": 2,
                "isUnlocked": false,
                "key": "plant4b",
                "class": "corndog",
            },
            "plant6": {
                "points": 1,
                "isUnlocked": false,
                "key": "plant6",
                "class": "horseradish",
            },
            "plant9": {
                "points": 2,
                "isUnlocked": false,
                "key": "plant9",
                "class": "squidbeet",
            },
            "plant8": {
                "points": 2,
                "isUnlocked": false,
                "key": "plant8",
                "class": "lobsterkale",
            },
            "plant5": {
                "points": 3,
                "isUnlocked": false,
                "key": "plant5",
                "class": "musselsprout",
            },
            "plant7": {
                "points": 3,
                "isUnlocked": false,
                "key": "plant7",
                "class": "kiwisquash",
            },
            "plant10": {
                "points": 4,
                "isUnlocked": false,
                "key": "plant10",
                "class": "urchintomato",
            },
            "plant11": {
                "points": 5,
                "isUnlocked": false,
                "key": "plant11",
                "class": "ottermelon",
            },
        }
    }
}
